const it = {
    _name: 'Italiano',
    _flag: '🇮🇹',
    // Nav
    'nav.dashboard': 'Dashboard',
    'nav.pos': 'Punto vendita',
    'nav.calcul': 'Calcolo prezzo',
    'nav.devis': 'Preventivi / Fatture',
    'nav.devisDeplacement': 'Preventivi a domicilio',
    'nav.commandes': 'Ordini',
    'nav.addDevice': 'Aggiungi dispositivo',
    'nav.reparations': 'Riparazioni',
    'nav.clients': 'Clienti',
    'nav.stock': 'Magazzino',
    'nav.addStock': 'Aggiungi magazzino',
    'nav.etiquettes': 'Etichette',
    'nav.users': 'Utenti',
    'nav.clientPwd': 'Password clienti',
    'nav.boutiqueOrders': 'Ordini negozio',
    'nav.caisseHistory': 'Storico cassa',
    'nav.database': 'Database',
    'nav.historique': 'Storico',
    'nav.paiements': 'Pagamenti online',
    'nav.chatClients': 'Chat clienti',
    'nav.chat': 'Messaggistica',
    'nav.notes': 'Note',
    'nav.logout': 'Disconnetti',
    'nav.quit': 'Esci',
    'nav.admin': 'Amministrazione',
    'nav.navigation': 'Navigazione',
    'nav.b2b': 'Gestione B2B',
    'nav.b2bPayments': 'Pagamenti B2B',
    'nav.brandsModels': 'Marche & Modelli',
    // Common
    'common.save': 'Salva',
    'common.cancel': 'Annulla',
    'common.delete': 'Elimina',
    'common.edit': 'Modifica',
    'common.search': 'Cerca',
    'common.add': 'Aggiungi',
    'common.close': 'Chiudi',
    'common.confirm': 'Conferma',
    'common.loading': 'Caricamento...',
    'common.noData': 'Nessun dato',
    'common.actions': 'Azioni',
    'common.status': 'Stato',
    'common.date': 'Data',
    'common.total': 'Totale',
    'common.print': 'Stampa',
    'common.yes': 'Sì',
    'common.no': 'No',
    'common.back': 'Indietro',
    'common.next': 'Avanti',
    'common.validate': 'Convalida',
    'common.ref': 'Riferimento',
    'common.client': 'Cliente',
    'common.phone': 'Telefono',
    'common.email': 'Email',
    'common.price': 'Prezzo',
    'common.quantity': 'Quantità',
    'common.amount': 'Importo',
    'common.send': 'Invia',
    'common.download': 'Scarica',
    'common.export': 'Esporta',
    'common.refresh': 'Aggiorna',
    'common.filter': 'Filtra',
    'common.all': 'Tutti',
    'common.name': 'Nome',
    'common.address': 'Indirizzo',
    'common.description': 'Descrizione',
    'common.payment': 'Pagamento',
    'common.paid': 'Pagato',
    'common.pending': 'In attesa',
    'common.accepted': 'Accettato',
    'common.refused': 'Rifiutato',
    // Layout
    'layout.panel': 'Pannello di gestione',
    // POS
    'pos.title': 'Punto di Vendita',
    'pos.scanner': 'Scanner',
    'pos.searchProduct': 'Cerca un prodotto (rif, nome, codice a barre)...',
    'pos.outOfStock': 'Esaurito',
    'pos.article': 'Articolo',
    'pos.unitPrice': 'Prezzo unit.',
    'pos.qty': 'Qtà',
    'pos.emptyCart': 'Carrello vuoto',
    'pos.checkout': 'Incasso',
    'pos.clientOptional': 'Cliente (opzionale)',
    'pos.discount': 'Sconto',
    'pos.subtotal': 'Subtotale',
    'pos.validateSale': 'Convalida la vendita',
    'pos.paymentMode': 'Metodo di pagamento',
    'pos.choosePayment': 'Scegli il metodo di pagamento:',
    'pos.cash': 'Contanti',
    'pos.card': 'Carta di credito',
    'pos.mixed': 'Misto',
    'pos.totalToCollect': 'Totale da incassare',
    'pos.change': 'Resto',
    'pos.confirmPayment': 'Conferma pagamento',
    'pos.validating': 'Convalida...',
    'pos.lastTicket': 'Ultimo scontrino',
    'pos.caisseClosed': 'La cassa è chiusa. Aprirla dal Dashboard per effettuare vendite.',
    'pos.insufficientCash': 'Importo contanti insufficiente',
    'pos.insufficientCard': 'Importo carta insufficiente',
    'pos.mixedMustEqual': 'Il pagamento misto deve essere uguale al totale',
    'pos.emptyCartAlert': 'Carrello vuoto',
    'pos.selectPayment': 'Selezionare un metodo di pagamento',
    'pos.saleValidated': 'Vendita convalidata!',
    'pos.adminOverride': 'Autorizzazione amministratore',
    'pos.outOfStockProduct': 'Prodotto esaurito',
    'pos.adminId': 'ID amministratore',
    'pos.adminCode': 'Codice amministratore',
    'pos.manualAdd': 'Aggiungi articolo non in magazzino',
    'pos.designation': 'Designazione',
    'pos.stockInsufficient': 'Scorte insufficienti',
    // Devis
    'devis.title': 'Preventivi & Fatture',
    'devis.subtitle': 'Documenti dal calcolo prezzo (convertibili in ordine).',
    'devis.noDoc': 'Nessun documento trovato',
    'devis.type': 'Tipo',
    'devis.convertConfirm': 'Convertire questo preventivo in ordine?',
    'devis.orderCreated': 'Ordine creato',
    'devis.deleteConfirm': 'Eliminare questo documento?',
    'devis.deleted': 'Documento eliminato',
    // Devis Déplacement
    'devDep.title': 'Preventivi a domicilio',
    'devDep.subtitle': 'Gestione preventivi per riparazioni a domicilio',
    'devDep.new': 'Nuovo preventivo',
    'devDep.edit': 'Modifica preventivo',
    'devDep.clientName': 'Nome cliente',
    'devDep.clientPhone': 'Telefono',
    'devDep.clientEmail': 'Email',
    'devDep.clientAddress': 'Indirizzo',
    'devDep.repairDesc': 'Descrizione della riparazione',
    'devDep.lines': 'Righe del preventivo',
    'devDep.addLine': 'Aggiungi',
    'devDep.travelFee': 'Spese di trasferta',
    'devDep.sendByEmail': 'Invia per email',
    'devDep.sending': 'Invio...',
    'devDep.pdfDevis': 'PDF Preventivo',
    'devDep.pdfBon': 'PDF Ordine',
    'devDep.pdfFacture': 'PDF Fattura',
    'devDep.searchPlaceholder': 'Cerca per rif, nome, email...',
    'devDep.allStatuses': 'Tutti gli stati',
    'devDep.pending': 'In attesa',
    'devDep.accepted': 'Accettato',
    'devDep.refused': 'Rifiutato',
    'devDep.depositPaid': 'Acconto versato',
    'devDep.fullyPaid': 'Pagato',
    'devDep.stats': 'Statistiche',
    'devDep.revenues': 'Ricavi',
    'devDep.activity30d': 'Attività degli ultimi 30 giorni',
    'devDep.remind': 'Sollecita',
    'devDep.remindConfirm': 'Inviare un promemoria ai clienti con preventivi in attesa da più di 3 giorni?',
    'devDep.noDevis': 'Nessun preventivo creato',
    'devDep.noResults': 'Nessun risultato',
    'devDep.bon': 'Ordine',
    'devDep.facture': 'Fattura',
    'devDep.emailSent': 'Email inviata il',
    'devDep.reminderSent': 'Promemoria inviato il',
    // Reparations
    'rep.title': 'Riparazioni',
    'rep.search': 'Cerca una riparazione...',
    'rep.new': 'Nuova riparazione',
    'rep.deviceRef': 'Rif. dispositivo',
    'rep.brand': 'Marca',
    'rep.model': 'Modello',
    'rep.problem': 'Problema',
    'rep.technician': 'Tecnico',
    'rep.timeline': 'Cronologia',
    // Commandes
    'cmd.title': 'Ordini',
    'cmd.search': 'Cerca un ordine...',
    'cmd.piece': 'Pezzo',
    'cmd.supplier': 'Fornitore',
    'cmd.deposit': 'Acconto',
    'cmd.remaining': 'Resto da pagare',
    // Clients
    'clients.title': 'Clienti',
    'clients.search': 'Cerca un cliente...',
    'clients.name': 'Nome',
    'clients.address': 'Indirizzo',
    'clients.addClient': 'Nuovo cliente',
    // Stock
    'stock.title': 'Gestione Magazzino',
    'stock.search': 'Cerca un articolo...',
    'stock.addArticle': 'Aggiungi articolo',
    'stock.category': 'Categoria',
    'stock.buyPrice': 'Prezzo acquisto',
    'stock.sellPrice': 'Prezzo vendita',
    'stock.available': 'Disponibile',
    // Dashboard
    'dash.title': 'Dashboard',
    'dash.openCaisse': 'Apri cassa',
    'dash.closeCaisse': 'Chiudi cassa',
    'dash.todaySales': 'Vendite di oggi',
    'dash.monthSales': 'Vendite del mese',
    'dash.activeRepairs': 'Riparazioni attive',
    'dash.pendingOrders': 'Ordini in attesa',
    // Login
    'login.title': 'Accesso',
    'login.username': 'Identificativo',
    'login.password': 'Codice di accesso',
    'login.submit': 'Accedi',
    'login.clientAccess': 'Accesso clienti',
    'login.staffAccess': 'Accesso personale',
    // Language
    'lang.select': 'Lingua',
    // Client Portal
    'client.space': 'Area Clienti',
    'client.repairs': 'Riparazioni',
    'client.boutique': 'Negozio',
    'client.orders': 'Ordini',
    'client.messages': 'Messaggi',
    'client.devis': 'Preventivi',
    'client.trackRepairs': 'Segui le tue riparazioni',
    'client.noRepairs': 'Nessuna riparazione in corso',
    'client.trackOrders': 'Segui i tuoi ordini',
    'client.noOrders': 'Nessun ordine in corso',
    'client.shop': 'Negozio online',
    'client.noProducts': 'Nessun prodotto disponibile',
    'client.addToCart': 'Aggiungi al carrello',
    'client.yourMessages': 'I tuoi messaggi',
    'client.noMessages': 'Nessun messaggio',
    'client.send': 'Invia',
    'client.brand': 'Marca',
    'client.model': 'Modello',
    'client.problem': 'Problema',
    'client.status': 'Stato',
    'client.deposit': 'Acconto',
    'client.remaining': 'Resto da pagare',
    'client.total': 'Totale',
    'client.timeline': 'Cronologia',
    'client.noDevis': 'Nessun preventivo al momento',
    'client.acceptRefuse': 'Accetta / Rifiuta',
    'client.pay': 'Paga',
    // Landing
    'landing.mobileRepair': 'Riparazione mobile nella Guyana Francese',
    'landing.staffSpace': 'AREA PERSONALE',
    'landing.staffDesc': 'Accesso team tecnico',
    'landing.clientSpace': 'AREA CLIENTI',
    'landing.clientDesc': 'Monitoraggio riparazioni',
    'landing.businessSpace': 'AREA AZIENDE',
    'landing.businessDesc': 'Portale B2B',
    'landing.contact': 'Contatto',
    'landing.callWhatsapp': 'Chiama & WhatsApp',
    'landing.writeUs': 'Scrivici direttamente',
    'landing.hours': 'Orari di apertura',
    'landing.legal': 'Informazioni legali',
    'landing.capital': 'con un capitale di',
    'landing.headquarters': 'Sede',
    'landing.allRights': 'Tutti i diritti riservati',
    'landing.heroSubtitle': 'Il vostro specialista di riparazione mobile nella Guyana Francese',
    'landing.mondayFriday': 'Lunedì - Venerdì',
    'landing.saturday': 'Sabato',
    'landing.sunday': 'Domenica',
    'landing.closed': 'Chiuso',
    'landing.companyType': 'Società per Azioni Semplificata (SAS)',
    'landing.openMaps': 'Apri in Maps',
    'landing.rcs': 'RCS',
    'landing.siret': 'SIRET',
    'landing.euid': 'EUID',
    'landing.shopAddress': 'Punto vendita',
    // Login extra
    'login.clientSpace': 'Area Clienti',
    'login.businessSpace': 'Area Aziende',
    'login.staffSpace': 'Area Personale',
    'login.connectYou': 'Accedi',
    'login.phoneNumber': 'Numero di telefono',
    'login.proEmail': 'Email professionale',
    'login.pin': 'Codice PIN (4 o 6 cifre)',
    'login.pinHint': 'Inserisci il codice tramite tastiera o tastierino numerico.',
    'login.connecting': 'Connessione...',
    'login.connect': 'Accedi',
    'login.noAccount': 'Non hai un account?',
    'login.createAccount': 'Crea un account',
    'login.forgotPwd': 'Password dimenticata?',
    'login.notRegistered': 'Non ancora registrato?',
    'login.businessRegister': 'Registrazione azienda',
    'login.secure': 'Accesso sicuro',
    'login.caricature': 'Creo la mia caricatura',
    'login.backHome': 'Torna alla home',
    'login.wrongCredentials': 'Credenziali errate',
    'login.pinError': 'Il codice PIN deve contenere 4 o 6 cifre',
    'login.b2bPassword': 'Password',
    'login.b2bPlaceholder': 'La tua password',
    'login.yourId': 'Il tuo identificativo',
    // Dashboard extra
    'dash.hello': 'Ciao',
    'dash.loggedAs': 'Connesso come',
    'dash.caisseOpen': 'Cassa aperta',
    'dash.closeCaisseReminder': 'Ricordati di chiudere la cassa',
    'dash.noCaisse': 'Nessuna cassa aperta',
    'dash.openCaisseTitle': 'Apri cassa',
    'dash.openTotal': 'Totale apertura',
    'dash.opening': 'Apertura...',
    'dash.open': 'Apri',
    'dash.searchPlaceholder': 'Cerca per riferimento, cliente, telefono...',
    'dash.noResults': 'Nessun risultato trovato',
    'dash.today': 'Oggi',
    'dash.thisMonth': 'Questo mese',
    'dash.completed': 'Completate',
    'dash.repairsSub': 'riparazioni',
    'dash.inProgress': 'In corso',
    'dash.waitingParts': 'in attesa pezzi incl.',
    'dash.registeredMonth': 'registrate questo mese',
    'dash.statsTitle': 'Statistiche & Analisi',
    'dash.statsDesc': 'Fatturato, riparazioni, B2B, clienti',
    'dash.brandsModelsLabel': 'Marche & Modelli',
    'dash.brandsModelsDesc': 'Gestisci il catalogo dispositivi',
    'dash.b2bPaymentsLabel': 'Pagamenti B2B',
    'dash.b2bPaymentsDesc': 'Monitoraggio fatture e pagamenti',
    'dash.stockAlerts': 'Avvisi magazzino',
    'dash.lowStock': 'prodotti con scorte basse',
    'dash.outOfStock': 'esauriti',
    'dash.recentRepairs': 'Ultime riparazioni',
    'dash.noClient': 'Senza cliente',
    'dash.unclosedTitle': 'Cassa non chiusa',
    'dash.unclosedNotClosed': 'non è stata chiusa',
    'dash.contactAdmin': 'Contattare un amministratore per chiuderla prima di continuare.',
    'dash.mustClose': 'Devi chiuderla prima di poter continuare a lavorare.',
    'dash.forceClose': 'Chiusura forzata',
    'dash.closing': 'Chiusura...',
    'dash.closeNormal': 'Chiudi normalmente',
    'dash.noCaisseToday': 'Nessuna cassa aperta oggi.',
    'dash.openQuestion': 'Vuoi aprire la cassa adesso?',
    'dash.dontOpen': 'Non aprire (continua)',
    'dash.salesBlocked': 'Le vendite sono bloccate finché la cassa non è aperta.',
    'dash.calculation': 'Calcolo',
    'dash.repairs': 'Riparazioni',
    'dash.addDevice': 'Aggiungi',
    'dash.clients': 'Clienti',
    'dash.openedBy': 'aperta da',
    'dash.unknown': 'sconosciuto',
    'dash.forceCloseConfirm': 'Forzare la chiusura della cassa del',
    'dash.errorForceClose': 'Errore nella chiusura forzata',
    'dash.errorOpenCaisse': "Errore nell'apertura della cassa",
    // Devis Accept
    'devisAccept.error': 'Errore',
    'devisAccept.notFound': 'Preventivo non trovato',
    'devisAccept.refused': 'Preventivo rifiutato',
    'devisAccept.refusedMsg': 'Hai rifiutato il preventivo',
    'devisAccept.thanks': 'Grazie per averci informato.',
    'devisAccept.accepted': 'Preventivo accettato!',
    'devisAccept.acceptedMsg': 'Grazie per aver accettato il preventivo',
    'devisAccept.bonCommande': "Buono d'ordine",
    'devisAccept.facture': 'Fattura',
    'devisAccept.emailSent': "Un'email con il buono d'ordine, il codice di convalida e le credenziali è stata inviata.",
    'devisAccept.proceedPayment': 'Procedi al pagamento',
    'devisAccept.paymentMsg': 'Per completare il tuo ordine, versa un acconto o il pagamento completo:',
    'devisAccept.deposit50': 'Acconto 50%',
    'devisAccept.fullPayment': 'Pagamento completo',
    'devisAccept.alreadyAccepted': 'Questo preventivo è già stato accettato.',
    'devisAccept.alreadyRefused': 'Questo preventivo è stato rifiutato.',
    'devisAccept.statusMsg': 'Stato del preventivo',
    'devisAccept.payDeposit': 'Paga acconto 50%',
    'devisAccept.homeRepairQuote': 'Preventivo riparazione a domicilio',
    'devisAccept.hello': 'Buongiorno',
    'devisAccept.findBelow': 'Trova qui di seguito i dettagli del tuo preventivo:',
    'devisAccept.designation': 'Designazione',
    'devisAccept.travelFee': 'Spese di trasferta',
    'devisAccept.tvaNote': 'IVA non applicabile, art. 293B del CGI. Preventivo valido 30 giorni.',
    'devisAccept.refuse': 'Rifiuta',
    'devisAccept.accept': 'Accetta il preventivo',
    'devisAccept.confirmRefuse': 'Sei sicuro di voler rifiutare questo preventivo?',
    // Payment
    'payment.secure': 'Pagamento sicuro',
    'payment.error': 'Errore',
    'payment.backToDevis': 'Torna al preventivo',
    'payment.notAccepted': 'Preventivo non accettato',
    'payment.mustAcceptFirst': 'Devi prima accettare il preventivo prima di procedere al pagamento.',
    'payment.viewDevis': 'Vedi preventivo',
    'payment.fullyPaid': 'Fattura completamente pagata',
    'payment.alreadyPaid': 'è già completamente pagato.',
    'payment.accessClient': 'Accedi alla tua area clienti',
    'payment.deposit50': 'Acconto 50%',
    'payment.fullPayment': 'Pagamento completo',
    'payment.devis': 'Preventivo',
    'payment.client': 'Cliente',
    'payment.totalDevis': 'Totale preventivo',
    'payment.alreadyPaidAmount': 'Già pagato',
    'payment.remaining': 'Resto da pagare',
    'payment.depositPercent': 'Acconto (50%)',
    'payment.amountToPay': 'Importo da pagare',
    'payment.pay': 'Paga',
    'payment.redirecting': 'Reindirizzamento a Stripe...',
    'payment.securedBy': 'Pagamento sicuro con Stripe',
    'payment.urlNotAvailable': 'URL di pagamento non disponibile',
    'payment.creationError': 'Errore nella creazione del pagamento',
    // Payment success
    'paySuccess.confirmed': 'Pagamento confermato!',
    'paySuccess.paymentFor': 'Il tuo pagamento per il preventivo',
    'paySuccess.registered': 'è stato registrato con successo.',
    'paySuccess.depositRegistered': 'Acconto registrato!',
    'paySuccess.depositFor': 'Il tuo acconto per il preventivo',
    'paySuccess.depositDone': 'è stato registrato.',
    'paySuccess.checking': 'Verifica in corso...',
    'paySuccess.pleaseWait': 'Stiamo verificando il tuo pagamento, attendere prego.',
    'paySuccess.waitingConfirm': 'In attesa di conferma',
    'paySuccess.processing': "Il tuo pagamento è in elaborazione. Riceverai un'email di conferma.",
    'paySuccess.totalInvoice': 'Totale fattura',
    'paySuccess.amountPaid': 'Importo pagato',
    'paySuccess.remaining': 'Resto da pagare',
    'paySuccess.payRemaining': 'Paga il resto',
    'paySuccess.loginClient': 'Accedi alla tua area clienti',
    // Registration
    'register.clientTitle': 'Crea un account cliente',
    'register.fullName': 'Nome completo',
    'register.phone': 'Telefono',
    'register.email': 'Email (opzionale)',
    'register.address': 'Indirizzo (opzionale)',
    'register.pin': 'Codice PIN (4 o 6 cifre)',
    'register.confirmPin': 'Conferma codice PIN',
    'register.creating': 'Creazione...',
    'register.createAccount': 'Crea il mio account',
    'register.alreadyAccount': 'Hai già un account?',
    'register.login': 'Accedi',
    'register.backHome': 'Torna alla home',
    'register.pinError': 'Il codice PIN deve contenere 4 o 6 cifre',
    'register.pinNoMatch': 'I codici PIN non corrispondono',
    'register.pinMinLength': 'Il codice PIN deve contenere almeno 4 cifre',
    // B2B Registration
    'b2bRegister.title': 'Registrazione Azienda',
    'b2bRegister.subtitle': 'Crea il tuo account professionale',
    'b2bRegister.companyName': "Nome dell'azienda",
    'b2bRegister.managerName': 'Nome del responsabile',
    'b2bRegister.proEmail': 'Email professionale',
    'b2bRegister.phone': 'Telefono',
    'b2bRegister.address': 'Indirizzo',
    'b2bRegister.siret': 'SIRET',
    'b2bRegister.password': 'Password',
    'b2bRegister.confirmPassword': 'Conferma password',
    'b2bRegister.kbis': 'Estratto KBIS (PDF)',
    'b2bRegister.kbisDesc': 'Carica il tuo estratto KBIS o documento giustificativo (PDF)',
    'b2bRegister.dropFile': 'Clicca o trascina il file qui',
    'b2bRegister.creating': 'Registrazione in corso...',
    'b2bRegister.submit': 'Registrati',
    'b2bRegister.success': 'Registrazione riuscita!',
    'b2bRegister.successMsg': "Il tuo account aziendale è in fase di convalida. Riceverai un'email di conferma.",
    'b2bRegister.goLogin': "Vai all'accesso",
    'b2bRegister.fillAll': 'Compilare tutti i campi obbligatori',
    'b2bRegister.siretError': 'Il SIRET deve contenere 14 cifre',
    'b2bRegister.pwdNoMatch': 'Le password non corrispondono',
    'b2bRegister.pwdMinLength': 'La password deve contenere almeno 6 caratteri',
    'b2bRegister.kbisRequired': 'Caricare il proprio estratto KBIS',
    'b2bRegister.alreadyAccount': 'Già registrato?',
    // Reset password
    'reset.forgotTitle': 'Password dimenticata',
    'reset.forgotDesc': 'Ricevi un link di reset via email',
    'reset.enterEmail': 'Inserisci la tua email',
    'reset.emailSent': 'Email inviata',
    'reset.emailSentMsg': "Se esiste un account con questo indirizzo, riceverai un'email con un link per reimpostare la password.",
    'reset.linkValid': 'Il link è valido per 1 ora.',
    'reset.backLogin': "Torna all'accesso",
    'reset.clientEmail': 'Indirizzo email del tuo account',
    'reset.sending': 'Invio...',
    'reset.sendLink': 'Invia link di reset',
    'reset.newPwdTitle': 'Nuova password',
    'reset.newPwdDesc': 'Scegli la tua nuova password',
    'reset.newPwd': 'Nuova password',
    'reset.confirmPwd': 'Conferma password',
    'reset.resetting': 'Reimpostazione...',
    'reset.resetPwd': 'Reimposta password',
    'reset.pwdReset': 'Password reimpostata',
    'reset.pwdResetMsg': 'La tua password è stata modificata con successo.',
    'reset.pwdMinLength': 'La password deve contenere almeno 4 caratteri',
    'reset.pwdNoMatch': 'Le password non corrispondono',
    'reset.error': 'Si è verificato un errore',
    // B2B Dashboard
    'b2b.welcome': 'Benvenuto',
    'b2b.newRepair': 'Nuova riparazione',
    'b2b.registerDevice': 'Registra un dispositivo',
    'b2b.myRepairs': 'Le mie riparazioni',
    'b2b.viewAll': 'Vedi tutte le riparazioni',
    'b2b.recentRepairs': 'Ultime riparazioni',
    'b2b.noRepairs': 'Nessuna riparazione',
    'b2b.repairRegistered': 'Riparazione registrata',
    'b2b.reference': 'Riferimento',
    'b2b.viewDetails': 'Vedi dettagli',
    'b2b.anotherRepair': 'Nuova riparazione',
    'b2b.deviceInfo': 'Informazioni dispositivo',
    'b2b.brand': 'Marca',
    'b2b.model': 'Modello',
    'b2b.backGlass': 'Vetro posteriore',
    'b2b.backGlassBroken': 'Vetro posteriore rotto',
    'b2b.backGlassOk': 'Vetro posteriore intatto',
    'b2b.providePart': 'Fornisco il pezzo',
    'b2b.partByShop': 'Il pezzo sarà fornito da R.E.Mobiles',
    'b2b.lockCode': 'Codice di sblocco',
    'b2b.lockTypeCode': 'Codice (numeri/lettere)',
    'b2b.lockTypeSchema': 'Schema',
    'b2b.problem': 'Problema / Descrizione',
    'b2b.brokenParts': 'Pezzi non funzionanti',
    'b2b.deliveryMethod': 'Metodo di consegna',
    'b2b.inStore': 'In negozio',
    'b2b.inStoreDesc': 'Consegna in negozio',
    'b2b.postal': 'Spedizione postale',
    'b2b.postalDesc': 'Con numero di tracciamento',
    'b2b.pickup': 'Ritiro',
    'b2b.pickupDesc': 'Veniamo a ritirare',
    'b2b.trackingNumber': 'Numero di tracciamento',
    'b2b.pickupAddress': 'Indirizzo di ritiro',
    'b2b.devicePhotos': 'Foto del dispositivo',
    'b2b.addPhotos': 'Clicca per aggiungere foto',
    'b2b.additionalNotes': 'Note aggiuntive',
    'b2b.submitting': 'Invio...',
    'b2b.submitRepair': 'Registra la riparazione',
    'b2b.brandModelRequired': 'Marca e modello sono obbligatori',
    'b2b.noRepairFound': 'Nessuna riparazione trovata',
    'b2b.allStatus': 'Tutte',
    'b2b.documents': 'Documenti & Fatture',
    'b2b.documentsDesc': "Convalida i tuoi buoni d'ordine e scarica le fatture",
    'b2b.pendingValidation': "Buoni d'ordine da convalidare",
    'b2b.enterCode': "Inserisci il codice ricevuto via email per convalidare ogni buono d'ordine.",
    'b2b.validate': 'Convalida',
    'b2b.invoices': 'Fatture',
    'b2b.noInvoices': 'Nessuna fattura disponibile',
    'b2b.device': 'Dispositivo',
    'b2b.amount': 'Importo',
    'b2b.date': 'Data',
    'b2b.actions': 'Azioni',
    'b2b.paid': 'Pagata',
    'b2b.repairAccepted': 'Riparazione accettata dal personale',
    'b2b.repairRefused': 'Riparazione rifiutata dal personale',
    'b2b.orderValidated': "Buono d'ordine convalidato",
    'b2b.noPhotos': 'Nessuna foto',
    'b2b.history': 'Storico',
    'b2b.repairPrice': 'Prezzo riparazione',
    'b2b.diagPrice': 'Prezzo diagnostica',
    'b2b.priceWaiting': 'In attesa - sarà fissato da R.E.Mobiles',
    'b2b.createdOn': 'Creata il',
    'b2b.clear': 'Cancella',
    'b2b.thisMonth': 'Questo mese',
    'b2b.waitingReception': 'Att. ricezione',
    'b2b.received': 'Ricevuto',
    'b2b.inProgress': 'In Corso',
    'b2b.waitingParts': 'Att. Pezzi',
    'b2b.completed': 'Completato',
    'b2b.delivered': 'Consegnato',
    // B2B Devis
    'b2bDevis.title': 'Preventivi a domicilio',
    'b2bDevis.pending': 'in attesa',
    'b2bDevis.noDevis': 'Nessun preventivo',
    'b2bDevis.noDevisDesc': 'Non hai preventivi a domicilio al momento.',
    'b2bDevis.travelFee': 'Spese di trasferta',
    'b2bDevis.validationCode': 'Codice di convalida',
    'b2bDevis.codeHint': 'Inserisci il codice a 6 cifre ricevuto via email.',
    'b2bDevis.acceptFirst': 'Accettare prima il preventivo per poterlo convalidare.',
    'b2bDevis.payDeposit': 'Paga acconto 50%',
    'b2bDevis.payFull': 'Paga il totale',
    'b2bDevis.payRemaining': 'Paga il resto',
    'b2bDevis.alreadyPaid': 'Già pagato',
    'b2bDevis.remaining': 'Resto da pagare',
    'b2bDevis.invoiceDownload': 'Scarica fattura',
    'b2bDevis.orderDownload': "Scarica buono d'ordine",
    'b2bDevis.quoteDownload': 'Scarica preventivo',
    // Admin Site Settings
    'adminSettings.title': 'Pagina principale',
    'adminSettings.preview': 'Anteprima',
    'adminSettings.saving': 'Salvataggio...',
    'adminSettings.save': 'Salva',
    'adminSettings.saved': 'Salvato!',
    'adminSettings.error': 'Errore',
    'adminSettings.heroSection': 'Hero / Intestazione',
    'adminSettings.mainTitle': 'Titolo principale',
    'adminSettings.subtitle': 'Sottotitolo',
    'adminSettings.accentColor': 'Colore accento (hex)',
    'adminSettings.bgImage': 'Immagine di sfondo',
    'adminSettings.change': 'Cambia',
    'adminSettings.companyInfo': 'Informazioni azienda',
    'adminSettings.companyName': 'Nome azienda',
    'adminSettings.companyType': 'Tipo (SAS, SARL...)',
    'adminSettings.capital': 'Capitale',
    'adminSettings.rcs': 'RCS',
    'adminSettings.siret': 'SIRET',
    'adminSettings.euid': 'EUID',
    'adminSettings.headquarters': 'Sede legale',
    'adminSettings.salesPoint': 'Punto vendita',
    'adminSettings.contactHours': 'Contatto & Orari',
    'adminSettings.phone': 'Telefono',
    'adminSettings.whatsapp': 'WhatsApp',
    'adminSettings.email': 'Email',
    'adminSettings.googleMaps': 'Ricerca Google Maps',
    'adminSettings.gallery': 'Galleria foto',
    'adminSettings.addImage': 'Aggiungi immagine',
    // Admin Database
    'adminDb.title': 'Amministrazione Database',
    'adminDb.subtitle': 'Esportazione, importazione e gestione dati',
    'adminDb.accessDenied': 'Accesso negato',
    'adminDb.adminOnly': 'Questa pagina è riservata agli amministratori',
    'adminDb.clients': 'Clienti',
    'adminDb.users': 'Utenti',
    'adminDb.repairs': 'Riparazioni',
    'adminDb.stockArticles': 'Articoli magazzino',
    'adminDb.exportTitle': 'Esporta database',
    'adminDb.exportDesc': 'Esporta tutti i dati (clienti, utenti, magazzino, riparazioni, vendite) in formato JSON.',
    'adminDb.exportConfirm': "Esportare l'intero database?",
    'adminDb.exportBtn': 'Esporta database completo',
    'adminDb.exportSuccess': 'Esportazione riuscita!',
    'adminDb.exportError': "Errore durante l'esportazione",
    'adminDb.importTitle': 'Importa database',
    'adminDb.importDesc': 'Importa un file JSON per ripristinare o migrare i dati.',
    'adminDb.fileSelected': 'File selezionato',
    'adminDb.uploading': 'Caricamento file...',
    'adminDb.importDone': 'Importazione completata!',
    'adminDb.importSuccess': 'Importazione riuscita!',
    'adminDb.importError': "Errore durante l'importazione",
    'adminDb.importClientsBtn': 'Importa clienti',
    'adminDb.importFullBtn': 'Importazione completa',
    'adminDb.importWarning': "L'importazione completa sostituirà i dati esistenti",
    'adminDb.importConfirm': 'ATTENZIONE: Questa azione sostituirà i dati esistenti. Continuare?',
    'adminDb.importClientsConfirm': 'Importare i clienti? Gli account saranno creati con il numero di telefono come identificativo.',
    'adminDb.selectFile': 'Selezionare un file',
    'adminDb.selectFileClients': 'Selezionare un file JSON con i clienti',
    'adminDb.logsTitle': 'Registro operazioni',
    'adminDb.noLogs': 'Nessuna operazione registrata',
    // Admin B2B
    'adminB2b.title': 'Gestione B2B',
    'adminB2b.home': 'Home',
    'adminB2b.monthlyRecap': 'Riepilogo mensile',
    'adminB2b.sending': 'Invio...',
    'adminB2b.search': 'Cerca...',
    'adminB2b.recapTitle': 'Risultato del riepilogo mensile',
    'adminB2b.recapSent': 'Inviato',
    'adminB2b.recapSkipped': 'Nessuna riparazione',
    'adminB2b.recapError': 'Errore',
    'adminB2b.companies': 'Aziende',
    'adminB2b.b2bRepairs': 'Riparazioni B2B',
    'adminB2b.paymentHistory': 'Storico pagamenti',
    'adminB2b.all': 'Tutte',
    'adminB2b.pending': 'In attesa',
    'adminB2b.validated': 'Convalidate',
    'adminB2b.refused': 'Rifiutate',
    'adminB2b.suspended': 'Sospese',
    'adminB2b.noCompany': 'Nessuna azienda trovata',
    'adminB2b.phone': 'Telefono',
    'adminB2b.siret': 'SIRET',
    'adminB2b.address': 'Indirizzo',
    'adminB2b.registeredOn': 'Registrata il',
    'adminB2b.validatedBy': 'Convalidata da',
    'adminB2b.downloadKbis': 'Scarica KBIS',
    'adminB2b.validate': 'Convalida',
    'adminB2b.refuse': 'Rifiuta',
    'adminB2b.suspend': 'Sospendi',
    'adminB2b.confirmValidate': "Vuoi convalidare quest'azienda?",
    'adminB2b.confirmRefuse': "Vuoi rifiutare quest'azienda?",
    'adminB2b.confirmSuspend': "Vuoi sospendere quest'azienda?",
    'adminB2b.pendingReception': 'In attesa di ricezione',
    'adminB2b.confirmReception': 'Conferma ricezione',
    'adminB2b.ref': 'Rif',
    'adminB2b.company': 'Azienda',
    'adminB2b.brandModel': 'Marca / Modello',
    'adminB2b.problem': 'Problema',
    'adminB2b.delivery': 'Consegna',
    'adminB2b.price': 'Prezzo',
    'adminB2b.status': 'Stato',
    'adminB2b.actions': 'Azioni',
    'adminB2b.noRepairs': 'Nessuna riparazione B2B trovata',
    'adminB2b.postal': 'Postale',
    'adminB2b.pickup': 'Ritiro',
    'adminB2b.inStore': 'Negozio',
    'adminB2b.changeStatus': 'Cambia stato',
    'adminB2b.setPrice': 'Fissa prezzo',
    'adminB2b.repairPrice': 'Prezzo riparazione',
    'adminB2b.diagPrice': 'Prezzo diagnostica',
    'adminB2b.locked': 'Bloccato (pagato)',
    'adminB2b.total': 'Totale',
    'adminB2b.existingInvoices': 'Fatture esistenti',
    'adminB2b.diagnostic': 'Diagnostica',
    'adminB2b.repair': 'Riparazione',
    'adminB2b.combined': 'Combinata',
    'adminB2b.paidMethod': 'Pagata',
    'adminB2b.awaitingPayment': 'In attesa',
    'adminB2b.markPaid': 'Pagata',
    'adminB2b.finalize': 'Finalizza fatturazione',
    'adminB2b.backGlassBroken': 'Vetro post. rotto',
    'adminB2b.clientPart': 'Pezzo cliente',
    'adminB2b.bcValidated': 'BO convalidato',
    'adminB2b.invoiceCancelled': 'Fattura annullata',
    'adminB2b.monthPrompt': 'Mese (1-12)? Lascia vuoto per il mese precedente:',
    'adminB2b.yearPrompt': 'Anno?',
    'adminB2b.paymentMethodPrompt': 'Metodo di pagamento?',
    'adminB2b.filterCompany': 'Azienda',
    'adminB2b.filterDateStart': 'Data inizio',
    'adminB2b.filterDateEnd': 'Data fine',
    'adminB2b.filter': 'Filtra',
    'adminB2b.clearFilter': 'Cancella',
    'adminB2b.totalCollected': 'Totale incassato',
    'adminB2b.payments': 'pagamento/i',
    'adminB2b.payHistoryTitle': 'Storico pagamenti B2B',
    'adminB2b.noPayments': 'Nessun pagamento B2B registrato',
    'adminB2b.invoice': 'Fattura',
    // Users Management
    'users.title': 'Gestione utenti',
    'users.count': 'utente/i',
    'users.new': 'Nuovo utente',
    'users.edit': "Modifica l'utente",
    'users.username': 'Nome utente',
    'users.password': 'Password',
    'users.newPassword': 'Nuova password (lascia vuoto per non cambiare)',
    'users.role': 'Ruolo',
    'users.roleAdmin': 'Amministratore',
    'users.roleUser': 'Commerciale',
    'users.roleTech': 'Tecnico',
    'users.status': 'Stato',
    'users.active': 'Attivo',
    'users.inactive': 'Inattivo',
    'users.createdAt': 'Creato il',
    'users.noUsers': 'Nessun utente',
    'users.accessDenied': 'Accesso riservato agli amministratori',
    'users.deleteConfirm': 'Eliminare questo utente?',
    // Clients (extra keys)
    'clients.manage': 'Gestione Clienti',
    'clients.total': 'clienti in totale',
    'clients.add': 'Aggiungi',
    'clients.noClients': 'Nessun cliente trovato',
    'clients.type': 'Tipo',
    'clients.discount': 'Sconto',
    'clients.account': 'Account',
    'clients.sent': 'Inviato',
    'clients.activeAccount': 'Attivo',
    'clients.noEmail': 'Nessuna email',
    'clients.editClient': 'Modifica cliente',
    'clients.newClient': 'Nuovo cliente',
    'clients.company': 'Azienda',
    'clients.clientType': 'Tipo di cliente',
    'clients.individual': 'Privato',
    'clients.business': 'Azienda',
    'clients.discountPct': 'Sconto (%)',
    'clients.deleteConfirm': 'Eliminare questo cliente?',
    'clients.page': 'Pagina',
    // Stats
    'stats.title': 'Statistiche & Analisi',
    'stats.revenue': 'Fatturato',
    'stats.repairs': 'Riparazioni',
    'stats.b2b': 'B2B',
    'stats.clients': 'Clienti',
    'stats.back': 'Indietro',
    'stats.monthlyRevenue': 'Fatturato mensile',
    'stats.revenueByType': 'Fatturato per tipo',
    'stats.revenueByPayment': 'Fatturato per metodo pagamento',
    'stats.totalRevenue': 'Fatturato totale (12 mesi)',
    'stats.repairsByStatus': 'Per stato',
    'stats.repairsByBrand': 'Per marca',
    'stats.topModels': 'Top modelli',
    'stats.monthly': 'Evoluzione mensile',
    'stats.totalRepairs': 'Riparazioni totali',
    'stats.avgRepairTime': 'Durata media',
    'stats.completionRate': 'Tasso completamento',
    'stats.b2bCompanies': 'Aziende B2B',
    'stats.b2bRepairs': 'Riparazioni B2B',
    'stats.b2bRevenue': 'Fatturato B2B',
    'stats.b2bByCompany': 'Per azienda',
    'stats.totalClients': 'Clienti totali',
    'stats.newThisMonth': 'Nuovi questo mese',
    'stats.withAccount': 'Con account',
    'stats.clientsByType': 'Per tipo',
    'stats.registrations': 'Registrazioni mensili',
    'stats.noData': 'Nessun dato',
    // Reparations (extra)
    'rep.manage': 'Gestione Riparazioni',
    'rep.noRepairs': 'Nessuna riparazione trovata',
    'rep.allStatuses': 'Tutti gli stati',
    'rep.imei': 'IMEI / Seriale',
    'rep.client': 'Cliente',
    'rep.phone': 'Tel.',
    'rep.date': 'Data',
    'rep.deposit': 'Acconto',
    'rep.printFiche': 'Stampa scheda',
    'rep.printEtiquette': 'Stampa etichetta',
    'rep.deleteConfirm': 'Eliminare questa riparazione?',
    'rep.addDeposit': 'Aggiungi acconto',
    'rep.depositAmount': 'Importo acconto',
    'rep.paymentMode': 'Metodo pagamento',
    'rep.depositHistory': 'Storico acconti',
    'rep.totalDeposits': 'Totale acconti',
    'rep.changeStatus': 'Cambia stato',
    'rep.notes': 'Note interne',
    'rep.sendChat': 'Invia messaggio',
    'rep.noTimeline': 'Nessun evento',
    // Commandes (extra)
    'cmd.manage': 'Gestione Ordini',
    'cmd.noOrders': 'Nessun ordine trovato',
    'cmd.allStatuses': 'Tutti gli stati',
    'cmd.ordered': 'Ordinato',
    'cmd.received': 'Ricevuto',
    'cmd.cancelled': 'Annullato',
    'cmd.status': 'Stato',
    'cmd.ref': 'Rif',
    'cmd.addOrder': 'Nuovo ordine',
    'cmd.editOrder': "Modifica l'ordine",
    'cmd.deleteConfirm': 'Eliminare questo ordine?',
    // Stock (extra)
    'stock.manage': 'Gestione Magazzino',
    'stock.noItems': 'Nessun articolo trovato',
    'stock.barcode': 'Codice a barre',
    'stock.reference': 'Riferimento',
    'stock.alert': 'Avviso',
    'stock.lowStockAlert': 'Scorte basse',
    'stock.addForm': 'Aggiungi articolo',
    'stock.editForm': "Modifica l'articolo",
    'stock.deleteConfirm': 'Eliminare questo articolo?',
    // Historique
    'hist.title': 'Storico vendite',
    'hist.search': 'Cerca una vendita...',
    'hist.noSales': 'Nessuna vendita trovata',
    'hist.ref': 'Rif.',
    'hist.client': 'Cliente',
    'hist.amount': 'Importo',
    'hist.payment': 'Pagamento',
    'hist.date': 'Data',
    'hist.articles': 'Articoli',
    'hist.refund': 'Rimborsa',
    'hist.refundConfirm': 'Rimborsare questa vendita?',
    // Paiements
    'pay.title': 'Pagamenti online',
    'pay.search': 'Cerca...',
    'pay.noPayments': 'Nessun pagamento trovato',
    'pay.ref': 'Riferimento',
    'pay.client': 'Cliente',
    'pay.amount': 'Importo',
    'pay.status': 'Stato',
    'pay.date': 'Data',
    'pay.type': 'Tipo',
    // Caisse
    'caisse.title': 'Storico Casse',
    'caisse.noCaisse': 'Nessuna cassa trovata',
    'caisse.openedBy': 'Aperta da',
    'caisse.openingAmount': 'Importo apertura',
    'caisse.closingAmount': 'Importo chiusura',
    'caisse.sales': 'Vendite',
    'caisse.openDate': 'Apertura',
    'caisse.closeDate': 'Chiusura',
    // Notes
    'notes.title': 'Note',
    'notes.new': 'Nuova nota',
    'notes.noNotes': 'Nessuna nota',
    'notes.deleteConfirm': 'Eliminare questa nota?',
    // Etiquettes
    'labels.title': 'Etichette',
    'labels.search': 'Cerca...',
    'labels.print': 'Stampa',
    'labels.selectAll': 'Seleziona tutto',
    'labels.noLabels': 'Nessuna etichetta',
    // Calcul Prix
    'calc.title': 'Calcolo Prezzo',
    'calc.searchDevice': 'Cerca un dispositivo...',
    'calc.selectRepair': 'Seleziona una riparazione',
    'calc.generateQuote': 'Genera preventivo',
    'calc.generateInvoice': 'Genera fattura',
    // Boutique
    'boutique.title': 'Ordini Negozio',
    'boutique.noOrders': 'Nessun ordine',
    'boutique.orderRef': 'Rif. ordine',
    'boutique.clientName': 'Cliente',
    'boutique.total': 'Totale',
    'boutique.status': 'Stato',
    // Chat
    'chat.title': 'Messaggistica',
    'chat.noConversations': 'Nessuna conversazione',
    'chat.typeMessage': 'Scrivi il tuo messaggio...',
    // Brands & Models
    'brands.title': 'Marche & Modelli',
    'brands.addBrand': 'Aggiungi marca',
    'brands.addModel': 'Aggiungi modello',
    'brands.noBrands': 'Nessuna marca',
    'brands.deleteConfirm': 'Eliminare questa marca?',
    // Remcaches
    'remcaches.title': 'Reset Cache',
    'remcaches.noItems': 'Nessun articolo',
    // Close Caisse
    'closeCaisse.title': 'Chiusura Cassa',
    'closeCaisse.countCoins': 'Conteggio contanti',
    'closeCaisse.theoreticalTotal': 'Totale teorico',
    'closeCaisse.actualTotal': 'Totale effettivo',
    'closeCaisse.difference': 'Differenza',
    'closeCaisse.close': 'Chiudi cassa',
    'closeCaisse.closing': 'Chiusura...',
    // Client Passwords
    'clientPwd.title': 'Password Clienti',
    'clientPwd.search': 'Cerca un cliente...',
    'clientPwd.noClients': 'Nessun cliente trovato',
    'clientPwd.generatePin': 'Genera PIN',
    'clientPwd.sendByEmail': 'Invia per email',
    // B2B Payments
    'b2bPay.title': 'Pagamenti B2B',
    'b2bPay.noPayments': 'Nessun pagamento',
    // Reparation Form
    'repForm.title': 'Aggiungi dispositivo',
    'repForm.editTitle': 'Modifica riparazione',
    'repForm.brand': 'Marca',
    'repForm.model': 'Modello',
    'repForm.imei': 'IMEI / N° di serie',
    'repForm.lockCode': 'Codice di sblocco',
    'repForm.problem': 'Problema riscontrato',
    'repForm.client': 'Cliente',
    'repForm.technician': 'Tecnico assegnato',
    'repForm.price': 'Prezzo riparazione',
    'repForm.submit': 'Salva',
    'repForm.submitting': 'Salvataggio...',
    'sumup.acceptOnlinePayment': 'Accetta pagamento online (SumUp)', 'sumup.acceptOnlinePaymentDesc': 'Il cliente potrà richiedere un link di pagamento SumUp', 'sumup.requestLink': 'Richiedi link pagamento SumUp', 'sumup.requestSent': 'Richiesta inviata! Riceverai il link via email.', 'sumup.alreadyRequested': 'Richiesta già in corso.', 'sumup.onlinePayment': 'Pagamento online SumUp', 'sumup.receiveLink': 'Ricevi un link di pagamento sicuro via email', 'sumup.linkRequested': 'Link richiesto', 'sumup.pendingRequests': 'Richieste link SumUp', 'sumup.pending': 'in attesa', 'sumup.pasteLinkHere': 'Incolla link SumUp qui...', 'sumup.send': 'Invia', 'sumup.linkSent': 'Link SumUp inviato al cliente via email!',
  };

export default it;
